import BenchmarkingMedicaidService from "@app/overviews/network-benchmarking-dashboard/benchmarkingMedicaidService";
import BenchmarkingQHPService from "@app/overviews/network-benchmarking-dashboard/benchmarkingQHPService";
import BenchmarkingService from "@app/overviews/network-benchmarking-dashboard/benchmarkingService";
import { CompetitiveInsightsMapOverlapTypeEnum } from "@app/overviews/network-benchmarking-dashboard/filters/shared/CompetitiveInsightsMapOverlapTypeEnum";

type BenchmarkingServiceType = BenchmarkingService | BenchmarkingQHPService | BenchmarkingMedicaidService;

function getMapOverlapColor(overlapType: CompetitiveInsightsMapOverlapTypeEnum): string {
  switch (overlapType) {
    case CompetitiveInsightsMapOverlapTypeEnum.One:
      return "overlapOneCountyFillColor";
    case CompetitiveInsightsMapOverlapTypeEnum.Two:
      return "overlapTwoCountyFillColor";
    case CompetitiveInsightsMapOverlapTypeEnum.Three:
      return "overlapThreeCountyFillColor";
    case CompetitiveInsightsMapOverlapTypeEnum.Four:
      return "overlapFourCountyFillColor";
    case CompetitiveInsightsMapOverlapTypeEnum.Five:
      return "overlapFiveCountyFillColor";
    default:
      return "";
  }
}

export {
  BenchmarkingServiceType,
  getMapOverlapColor,
};